"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Event = void 0;
class Event {
    constructor(eventEmitter, eventId) {
        this.eventEmitter = eventEmitter;
        this.eventId = eventId;
    }
    subscibe(listener) {
        this.eventEmitter.addListener(this.eventId, listener);
        return {
            unsubscribe: () => this.eventEmitter.removeListener(this.eventId, listener),
        };
    }
    publish(payload) {
        this.eventEmitter.emit(this.eventId, payload);
    }
}
exports.Event = Event;
//# sourceMappingURL=event.js.map